// 自動スクロール用スクリプト

// カードリストを複製して、アニメーションさせる
document.addEventListener('DOMContentLoaded', () => {
    const tracks = document.querySelectorAll('.lpcb-move-card-scroll-track');
  
    tracks.forEach(track => {
        const list = track.querySelector('.lpcb-move-card-list');
        if (!list) return;
  
        // すでに複製済みならスキップ
        if (track.querySelectorAll('.lpcb-move-card-list').length > 1) return;

        const clone = list.cloneNode(true);
        track.appendChild(clone);
  
        const isReverse = list.classList.contains('is-scrolling-reverse');

        clone.classList.remove('is-scrolling', 'is-scrolling-reverse');
        list.classList.remove('is-scrolling', 'is-scrolling-reverse');
        
        void clone.offsetHeight;
        void list.offsetHeight;

        // クラス再適用
        if (isReverse) {
            list.classList.add('is-scrolling-reverse');
            clone.classList.add('is-scrolling-reverse');
        } else {
            list.classList.add('is-scrolling');
            clone.classList.add('is-scrolling');
        }

        setTimeout(() => {
          clone.style.animationPlayState = 'running';
          list.style.animationPlayState = 'running';
        }, 3000);
    });
});

// マウスがカード領域に入ると一時停止させる,離れると再開させる
document.querySelectorAll('.lpcb-move-card-scroll-container').forEach(container => {
  let isPaused = false;

  // PC用 マウスオーバー
  container.addEventListener('mouseenter', () => {
    container.querySelectorAll('.is-scrolling, .is-scrolling-reverse').forEach(list => {
      list.style.animationPlayState = 'paused';
    });
    isPaused = true;
  });
  container.addEventListener('mouseleave', () => {
    container.querySelectorAll('.is-scrolling, .is-scrolling-reverse').forEach(list => {
      list.style.animationPlayState = 'running';
    });
    isPaused = false;
  });

  // スマホ用 タップでトグルする
  container.addEventListener('touchend', (e) => {
    isPaused = !isPaused;
    container.querySelectorAll('.is-scrolling, .is-scrolling-reverse').forEach(list => {
      list.style.animationPlayState = isPaused ? 'paused' : 'running';
    });
    // ダブルタップによる拡大防止
    e.preventDefault();
  });
});
